import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Button from "../../Button";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {FormattedMessage} from "react-intl";
import BaseForm from "./BaseForm";

class ButtonAdd extends Component {
  constructor(props) {
    super(props);

    this.baseForm = React.createRef();

    this.state = {
      modalOpen: false,
      creating: false,
    };

    this.save = this.save.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
  }

  save(){
    this.baseForm.current.save();
  }

  toggleModal(){
    this.setState({
      modalOpen: !this.state.modalOpen,
    })
  }

  render() {
    const {creating, modalOpen} = this.state;

    return <React.Fragment>
      <Button onClick={this.toggleModal}><i className="fas fa-plus" /> Dodaj nową bazę</Button>
      <Modal isOpen={modalOpen} toggle={this.toggleModal} size="lg">
        <ModalHeader tag="h2" toggle={this.toggleModal}>Dodaj nową bazę</ModalHeader>
        <hr className="my-0"/>
        <ModalBody>
          <BaseForm
            ref={this.baseForm}
            onAdded={this.props.onAdded}
            onSavingStart={() => this.setState({creating: true})}
            onSavingStop={() => this.setState({creating: false})}
          />
        </ModalBody>
        <ModalFooter>
          <FormattedMessage id="_.button.cancel">{
            (message) =>
              <Button color="secondary" className={['mb-0']} onClick={this.toggleModal}>{message}</Button>
          }</FormattedMessage>
          <FormattedMessage id="_.button.save">{
            (message) => <Button
              color="primary"
              loading={creating}
              onClick={this.save}
            >
              {message}
            </Button>
          }</FormattedMessage>
        </ModalFooter>
      </Modal>
    </React.Fragment>;
  }
}

ButtonAdd.propTypes = {
  onAdded: PropTypes.func.isRequired,
};

export default ButtonAdd;